// extracted by mini-css-extract-plugin
export default {"image":"KlI97","asset":"GZuJ8"};